import logoImage from './../../images/crowcloud.png';

export default class LoginController {

    static get $inject() {
        return [
            '$state', 'UiHelper', 'AlertsService', 'AuthService', 'LanguageService', '$element', 'ApiAccountService',
            'UserCodeService', 'CookiesService'
        ];
    }

    constructor($state, UiHelper, AlertsService, AuthService, LanguageService, $element, ApiAccountService,
                UserCodeService, CookiesService) {

        this.$state = $state;
        this.UiHelper = UiHelper;
        this._AuthService = AuthService;
        this.LanguageService = LanguageService;
        this.ApiAccountService = ApiAccountService;
        this._AlertsService = AlertsService;
        this.UserCodeService = UserCodeService;
        this.CookiesService = CookiesService;
        this.UserCodeService.deleteUserCode();
        this._AlertsService.add = this._AlertsService.add.bind(this._AlertsService);
        document.body.style.backgroundColor = 'white';

        this.formData = {
            email: '',
            password: ''
        };

        $element.on('$destroy', () => {
            this.closeModal('langModal');
        });

    }

    closeModal(modalName) {
        this.UiHelper.closeModal(modalName);
    }

    showModal(modalName) {
        this.UiHelper.showModal(modalName);
    }

    submit() {
        let termOfServiceIdCookie = this.CookiesService.getCookie('termsOfServiceId');
        this._AlertsService.reset();

        this._AuthService.login(this.formData)
            .then(() => {
                this.ApiAccountService.getUserDetails();
                this.$state.go('main');
                this.ApiAccountService.setEndPoint();
            })
            .catch(r => {
                this._AlertsService.add(r);
            });
    }

    get logoImage() {
        return logoImage;
    }

}












/** WEBPACK FOOTER **
 ** ./src/guest/login/controller.js
 **/